module.exports = __webpack_public_path__ + "static/media/bindQQ1.0713c4c4.png";